import { parentApi } from '@/api/parent'
import {
  clearParentSession,
  getParentActiveStudentId,
  setParentActiveStudentId
} from '@/utils/parentSession'

export default {
  namespaced: true,
  state: () => ({
    // 登录态以服务端 httpOnly cookie 为准；此处仅保存本次会话内的内存态
    token: '',
    phone: '',
    students: [],
    activeStudentId: getParentActiveStudentId()
  }),
  getters: {
    isLoggedIn: (s) => !!s.token,
    activeStudent: (s) =>
      s.students.find((x) => x._id === s.activeStudentId) || s.students[0] || null
  },
  mutations: {
    SET_TOKEN(state, t) {
      // token 由后端通过 httpOnly cookie 下发与持久化，前端不再写入存储，
      // 仅保留内存态供本次会话内使用，避免覆盖 httpOnly cookie
      state.token = t || ''
    },
    SET_ME(state, { phone, students }) {
      state.phone = phone
      state.students = students || []
      if (!state.activeStudentId && state.students.length) {
        state.activeStudentId = state.students[0]._id
        setParentActiveStudentId(state.activeStudentId)
      }
    },
    SET_ACTIVE_STUDENT(state, id) {
      state.activeStudentId = id
      setParentActiveStudentId(id)
    },
    CLEAR(state) {
      state.token = ''
      state.phone = ''
      state.students = []
      state.activeStudentId = ''
      clearParentSession()
    }
  },
  actions: {
    async login({ commit, dispatch }, { phone, password }) {
      const res = await parentApi.login(phone, password)
      commit('SET_TOKEN', res.data.token)
      await dispatch('fetchMe')
    },
    async setup({ commit, dispatch }, { phone, password }) {
      const res = await parentApi.setup(phone, password)
      commit('SET_TOKEN', res.data.token)
      await dispatch('fetchMe')
    },
    async fetchMe({ commit }) {
      const res = await parentApi.me()
      commit('SET_ME', res.data)
    },
    async logout({ commit }) {
      try {
        await parentApi.logout()
      } catch (e) {
        // ignore network errors at logout time
      }
      commit('CLEAR')
    },
    setActiveStudent({ commit }, id) {
      commit('SET_ACTIVE_STUDENT', id)
    }
  }
}
